// Break points ---------------------------------------------------------------
var small = 540;
var medium = 768;

$(document).ready(function () {
    var slidesLarge = 3;
    var slidesMedium = 2;

    if ($('.testimonials-carousel').length) {
        var numTestimonials = $('.testimonials-carousel .single-testimonial').length;
        if (numTestimonials == 2) {
            slidesLarge = 2;
        } else if (numTestimonials == 1) {
            slidesLarge = 1;
            slidesMedium = 1;
        }
    }

    $('.testimonials-carousel').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        slidesToShow: slidesLarge,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        swipeToSlide: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: slidesMedium
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $(".faq-q").click(function () {

            $(this).next().slideToggle(300);

        $(this).children("svg").toggleClass("rotated");
    })

    replaceGloboAtcText(0);
}) 

function replaceGloboAtcText(retry) {
    let globoATC = document.getElementsByClassName("add-to-cart-btn ga-product_addtocart");

    if (globoATC.length > 0) {
        for (let i = 0; i < globoATC.length; i++) {
            globoATC[i].innerHTML = "In den Warenkorb";
        }
    } else if (retry < 10){
      setTimeout(function(){replaceGloboAtcText(retry + 1)}, 500);
    }
}